import { DISCOUNT } from "./discount";

export const ITEMS = {
	DISCOUNT,
};
export type { DiscountTypeForQueryParams } from "./discount";
